import { getSECURE_API, API, baseURL, TOKEN_KEY, sendFormDataRequest } from 'api';
import axios from 'axios';

const SECURE_API = getSECURE_API();
export const getAll = () => SECURE_API.get('/games/platforms');
export const getMe = () => SECURE_API.get('/games/me');
export const getMyBookings = () => SECURE_API.get('/games/bookings');
export const deleteGameApi = (id) => SECURE_API.delete(`/games/${id}`);
export const getGameFromGAP = () => SECURE_API.get('gap/compare-add');

export const createGame = (game, successCallback) =>
  sendFormDataRequest('/games', 'POST', game, 'image', successCallback);

export const updatePassword = (body) =>
  axios.put(
    `${baseURL}/auth/update-password`,
    {
      ...body,
    },
    {
      headers: {
        Authorization: `Bearer ${localStorage.getItem(TOKEN_KEY)}`,
      },
    },
  );

export const updateGameApi = (id, updatedgame, successCallback) =>
  sendFormDataRequest(`/games/${id}`, 'PUT', updatedgame, 'image', successCallback);
